import { useQuery } from '@tanstack/react-query';

import dtStatus from '../status';
import fetch from './fetch';

/**
 * @param {object} params
 * @param {string} params.code
 * @param {boolean} params.enabled
 */
function useDtTradelimit({ code: stockCode, enabled: propsEnabled = true } = {}) {
  const { cb, key } = fetch(stockCode);

  const { isDtActive } = dtStatus.useDtAccountStatus();

  const enabled =
    isDtActive && // Do not call when user does not have DT account
    !!stockCode && // Do not call without stock code
    propsEnabled; // Do not call when service client specifies it

  const { data, isSuccess, refetch } = useQuery(key, cb, { enabled });

  /** Funds that are available for trading */
  const dtBuyingPower = data?.buying_power || 0;

  /**
   * With a given trading limit, what is the maximum possible trading order volume
   * if user decided to spend all of their funds
   * Formula: `buying_power - max_fee`
   * If `buying_power` is less than `max_fee`, return 0
   * */
  const usableDtBuyingPower =
    (data?.buying_power || 0) > (data?.max_fee || 0)
      ? (data?.buying_power || 0) - (data?.max_fee || 0)
      : 0;

  return { data, isSuccess, refetch, dtBuyingPower, usableDtBuyingPower };
}

export default {
  useDtTradelimit,
};
